import type {
  ConditionKind,
  TreeGroupNode,
} from '@/components/tree-dnd/tree-dnd-types';
import { HIDDEN_CONDITION_KINDS } from '@/components/tree-dnd/tree-dnd-conditions/registry';
import { treeHasNestedGroups } from '@/components/tree-dnd/tree-dnd-utils';

/** Condition kinds that cannot be saved via the current API mapper. */
const UNSUPPORTED_CONDITION_KINDS = new Set<ConditionKind>([
  'rfmGroup',
  'location',
]);

export function isSimplifiedCompatibleFilterTree(root: TreeGroupNode): boolean {
  if (root.operator !== 'AND' || root.negated) return false;
  if (treeHasNestedGroups(root)) return false;

  const kinds = new Set<ConditionKind>();

  for (const child of root.children) {
    if (child.type !== 'condition') return false;
    if (
      HIDDEN_CONDITION_KINDS.has(child.kind) ||
      UNSUPPORTED_CONDITION_KINDS.has(child.kind)
    ) {
      return false;
    }
    if (kinds.has(child.kind)) return false;
    kinds.add(child.kind);
  }

  return true;
}

export function getAudienceEditPath(
  tenantSlug: string,
  audienceId: string,
  filterTree: TreeGroupNode
): string {
  const suffix = isSimplifiedCompatibleFilterTree(filterTree)
    ? 'edit'
    : 'edit-advanced';
  return `/${tenantSlug}/audiences/${audienceId}/${suffix}`;
}
